import React from 'react'
import BaseHeading from './BaseHeading'

interface PropsType {
  children: React.ReactNode
}

const EmphasisHeading = (props: PropsType) => <BaseHeading $borderColor="#ec4444">{props.children}</BaseHeading>

export default EmphasisHeading
